module.exports = __webpack_public_path__ + "img/gateway-light-switch-lg.8ecff1cb.svg";